import React from 'react'
import ZocksIcon from '../../../assets/images/ZocksIcon-primary.svg?url'

interface OAuthAppIconsProps {
  imageUrl: string | null
  appName: string
}

export const OAuthAppIcons: React.FC<OAuthAppIconsProps> = ({ imageUrl, appName }) => {
  const initials = appName.slice(0, 2).toUpperCase() || '?'

  return (
    <div className='d-flex align-items-center justify-content-center gap-2 oauth-mb-40'>
      <div className='oauth-icon-circle'>
        {imageUrl ? <img src={imageUrl} alt={`${appName} logo`} className='oauth-icon-img' /> : <span className='oauth-icon-initials'>{initials}</span>}
      </div>
      <div className='d-flex align-items-center oauth-dot-gap'>
        {[0, 1, 2].map((i) => {
          return <div key={i} className='oauth-icon-dot' />
        })}
      </div>
      <div className='oauth-icon-circle'>
        <img src={ZocksIcon} alt='Zocks logo' className='oauth-icon-img' />
      </div>
    </div>
  )
}
